<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('approvalWorkFlow.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-loading-banner :loading="loadingPreData">
      <ts-card-wrapper>
        <ConDetails v-model="model.conDetails" />
      </ts-card-wrapper>
      <hr />
      <ts-card-wrapper>
        <div class="text-right">
          <ts-button class="btn-default mr-2" @click.prevent="$emit('close')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            class="btn-primary"
            @click.prevent="save"
            :waiting="saving"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </ts-card-wrapper>
    </ts-loading-banner>
  </ts-card>
</template>

<script>
import { mapActions } from 'vuex'
import ConDetails from './add-condition-detail.vue'

export default {
  name: 'addCondition',
  props: ['editData'],
  components: { ConDetails },

  data() {
    return {
      model: {
        conDetails: []
      },
      loadingPreData: false,
      saving: false,
      value: {}
    }
  },

  created() {
    this.loadingPreData = true
    Promise.all([
      this.fetchPosition(),
      this.fetchEmployees(),
      this.fetchProgramMain(),
      this.fetchProgramSub(),
      this.fetchLevel(),
      this.fetchGrade()
    ]).then(() => {
      this.loadingPreData = false
      this.fetchResource()
    })
  },

  methods: {
    ...mapActions('approvalWorkFlow', [
      'saveCodition',
      'fetchPosition',
      'fetchEmployees',
      'fetchProgramMain',
      'fetchProgramSub',
      'fetchLevel',
      'fetchGrade'
    ]),
    async fetchResource() {
      this.loadingPreData = true
      await this.$store
        .dispatch('approvalWorkFlow/fetchResource')
        .then(() => {
          this.setEdit(this.editData)
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    setEdit(data) {
      if (data === null || data === undefined) return
      this.model.conDetails = data.details
    },

    save() {
      this.saving = true

      this.$store
        .dispatch('approvalWorkFlow/storeCondition', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
hr {
  border: 1px solid #dedede;
}
</style>
